var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ModifierKey } from '../types';
import { Dom } from '../util';
import { Base } from './base';
export class PanningManager extends Base {
    get widgetOptions() {
        return this.options.panning;
    }
    get pannable() {
        return this.widgetOptions && this.widgetOptions.enabled === true;
    }
    init() {
        this.startListening();
        this.updateClassName();
    }
    startListening() {
        this.graph.on('blank:mousedown', this.preparePanning, this);
        this.graph.on('node:unhandled:mousedown', this.preparePanning, this);
        this.graph.on('edge:unhandled:mousedown', this.preparePanning, this);
    }
    stopListening() {
        this.graph.off('blank:mousedown', this.preparePanning, this);
        this.graph.off('node:unhandled:mousedown', this.preparePanning, this);
        this.graph.off('edge:unhandled:mousedown', this.preparePanning, this);
    }
    preparePanning({ e }) {
        if (this.allowPanning(e, true) ||
            (this.allowPanning(e) && !this.graph.selection.allowRubberband(e, true))) {
            this.startPanning(e);
        }
    }
    allowPanning(e, strict) {
        return (this.pannable &&
            ModifierKey.isMatch(e, this.widgetOptions.modifiers, strict) &&
            this.graph.hook.allowPanning(e));
    }
    startPanning(evt) {
        const e = this.view.normalizeEvent(evt);
        this.clientX = e.clientX;
        this.clientY = e.clientY;
        this.panning = true;
        this.updateClassName();
        this.view.$(document.body).on({
            'mousemove.panning touchmove.panning': this.pan.bind(this),
            'mouseup.panning touchend.panning': this.stopPanning.bind(this),
        });
        this.view.$(window).on('mouseup.panning', this.stopPanning.bind(this));
    }
    pan(evt) {
        const e = this.view.normalizeEvent(evt);
        const dx = e.clientX - this.clientX;
        const dy = e.clientY - this.clientY;
        this.clientX = e.clientX;
        this.clientY = e.clientY;
        this.graph.translateBy(dx, dy);
    }
    stopPanning(e) {
        this.panning = false;
        this.updateClassName();
        this.view.$(document.body).off('.panning');
        this.view.$(window).off('.panning');
    }
    updateClassName() {
        const container = this.view.container;
        const panning = this.view.prefixClassName('graph-panning');
        const pannable = this.view.prefixClassName('graph-pannable');
        if (this.pannable) {
            if (this.panning) {
                Dom.addClass(container, panning);
                Dom.removeClass(container, pannable);
            }
            else {
                Dom.removeClass(container, panning);
                Dom.addClass(container, pannable);
            }
        }
        else {
            Dom.removeClass(container, panning);
            Dom.removeClass(container, pannable);
        }
    }
    enablePanning() {
        if (!this.pannable) {
            this.widgetOptions.enabled = true;
            this.updateClassName();
            // if (
            //   ModifierKey.equals(
            //     this.graph.options.panning.modifiers,
            //     this.graph.options.selecting.modifiers,
            //   )
            // ) {
            //   this.graph.selection.disableRubberband()
            // }
        }
    }
    disablePanning() {
        if (this.pannable) {
            this.widgetOptions.enabled = false;
            this.updateClassName();
        }
    }
    dispose() {
        this.stopListening();
    }
}
__decorate([
    Base.dispose()
], PanningManager.prototype, "dispose", null);
//# sourceMappingURL=panning.js.map